module.exports = __webpack_public_path__ + "img/trips-1.eb1b7538.gif";